import React from 'react'
import { apiDelete, apiPost, apiPut, apiGet } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import Technologies from '../technologies/Technology'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueDescription, systemValueLabel } from '../../generic/systemValues/systemValueLabel'

const ToolGroup = (props) => {
  const { addModeByDefault = false, handleRowCreatedInOtherSmartTable } = props
  const { t_ } = useSmartTranslation()
  const columns = [{
    name: t_('Code'),
    field: 'code',
    charLimit: 60,
    mandatory: true,
    unique: true,
    readOnly: (toolGroup) => !!toolGroup.systemDefault
  },
  {
    name: t_('Name'),
    field: 'name',
    render: (row) => systemValueLabel(t_, 'tool_group', row),
    renderOnlyInReadMode: true,
    charLimit: 80,
    mandatory: true,
    unique: true,
    readOnly: (toolGroup) => !!toolGroup.systemDefault
  },
  {
    name: t_('Description'),
    field: 'description',
    charLimit: 200,
    // P10: a seeded row's description is factory text and reads translated; a customer row keeps its own.
    render: (row) => systemValueDescription(t_, 'tool_group', row),
    renderOnlyInReadMode: true
  },
  {
    name: t_('Technology'),
    field: 'technologies.name',
    type: 'smartMultiSelect',
    content: <Technologies handleRowCreatedInOtherSmartTable={handleRowCreatedInOtherSmartTable} addModeByDefault />,
    edit: {
      source: async () => {
        return await apiGet('technologiesBasicData')
      },
      id: 'id',
      field: 'name'
    },
    mandatory: true
  }
  ]

  const actions = {
    edit: {
      fetchFunction: (row) => {
        return apiPut('toolGroups', row)
      }
    },
    create: {
      fetchFunction: (row) => {
        return apiPost('toolGroups', row)
      }
    },
    delete: {
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('toolGroups/' + rows[0].id, rows)
        } else {
          return apiDelete('toolGroupsMulti', rows)
        }
      },
      visibilityButton: (toolGroup) => !toolGroup.systemDefault
    }
  }
  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='toolGroup'
      columns={columns}
      title={t_('Tool groups')}
      dataFetch='toolGroups'
      actions={actions}
      multipleSelection
      addModeByDefault={addModeByDefault}
      handleRowCreatedInOtherSmartTable={handleRowCreatedInOtherSmartTable}
      multipleOptions
      pageable
    />
  )
}

export default ToolGroup
